import { render, staticRenderFns } from "./Cotas.vue?vue&type=template&id=697782b0&scoped=true&"
import script from "./Cotas.vue?vue&type=script&lang=js&"
export * from "./Cotas.vue?vue&type=script&lang=js&"
import style0 from "./Cotas.vue?vue&type=style&index=0&id=697782b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697782b0",
  null
  
)

export default component.exports